import React, {Component} from 'react';
import styled from 'styled-components';
import {Grid, Row, Col} from 'react-bootstrap';
import ProfileCard from './components/ProfileCard.js';
import MediaFrame from './components/MediaFrame.js';
import HeaderContent from './components/HeaderContent.js';
import ListContent from './components/ListContent.js';

const photography = require.context('./img/photography', true);
const pictures = [
  './pic1.png',
  './pic2.png',
  './pic3.png',
  './pic4.png',
  './pic5.png',
  './pic6.png',
  './pic0.png'
].map(name => photography(name, true));
const picturesDesc = "All the photos below were taken the summer of 2017. My family and I travelled to Seattle and Banff / Jasper National Park. The year I went was very special because it was Canada's 150 year anniversary of Parks Canada.";
const projects = require.context('./img/projects', true);
const projectPictures = ['./encryption.png', './wpm.png'].map(name => projects(name, true));
const projectLinks = ['https://talonjin.github.io/encrypt/', 'https://talonjin.github.io/wpm/'];
const projectPicturesDesc = "Here are some highlights of the projects I've worked on. Click on the image see the project!";
const profile = require.context('./img/profile', true);

var csCourses = [
  <span>
    <b>CS 135 </b>
    Functional Programming
  </span>,
  <span>
    <b>CS 136  </b>
    Algorithm Design
  </span>
]
var awards = [
  <span> <b> President's Scholarship of Distinction, </b> Univeristy of Waterloo </span>,
  <span> <b> Canadian Computing Competition, </b> Top 10% Senior Level </span>,
  <span> <b> Physics Distinction Award </b> </span>,
  <span> <b> Vaughan Aquatic Club, </b> <br/> 50m Butterfly club Record </span>,
];
var interests = [
  '🎾 Tennis',
  '🏓 Table Tennis',
  '🏸 Badminton',
  '🏊‍♂️ Competitive Swimming',
  '🏀 Basketball',
  '🎲 Board Games (Catan)',
  '🎹 Piano',
  '🏒 Hockey'
];
var starterHacks = ['Integrated Tesseract Optical Character Recognition to identify scrambled words in a word search', 'Incorporated standard Python GUI Tkinter to return the result of all words found from a word bank'];
var crypWebApp = ['Designed cryptography web app that highlights two simple substitution ciphers; Substitution cipher and Vigenère cipher', 'Employed functional techniques using React'];
var wordsWebApp = ['Developed simple words per minute application that provides users to test their typing speed', 'Project utilizes similar components and structure to Cryptography Web App, demonstrating effective code reuse by using React components']
var digitalMediaAcademy = ['Programmed League of Legends mini arcade game with player movement using Pygame', 'Integrated user input for keyboard and mouse controls'];
var autoVehicle = ['Programmed autonomous vehicles to detect and avoid obstacles based on sensor data in real time using Python and LEGO Mindstorms', 'Deployed program onto LEGO Mindstorm vehicle'];
var swimmingInstructor = ['Taught children of various levels including impaired swimmers the fundamental techniques of swimming and floating', 'Integrated water safety lessons and games', 'Communicated with parents/guardians regarding the swimmers strengths and areas of improvement'];

class App extends Component {
  render() {
    return (<div className="background">
      <Grid>
        <Row>
          <Col xs={12} md={4}>
            <div className="card">
              <ProfileCard profile={profile('./MainFace.png')} cover={profile('./MainCover.png')} name="Talon Jin" about="Honors Computer Science student at the University of Waterloo. I enjoy swimming, traveling, and coding"/>
            </div>

            <div className="card content">
              <h1>🎓 Education</h1>
              <p>
                <b>University of Waterloo</b><br/>BCS, Honors Computer Science
              </p>
            </div>

            <div className="card content">
              <h1>💻 Skills</h1>
              <p>
                <b>Languages:</b>Python, C, Java, Racket, JavaScript, Git
              </p>
              <p>
                <b>Design:</b> React, JSX, Flux, HTML, CSS
              </p>
            </div>

            <div className="card content">
              <h1>👾 Hackathons</h1>
              <p> <b>DeltaHacks V</b>, 2019 McMaster University </p>
              <p> <b>StarterHacks</b>, 2019 Univeristy of Waterloo </p>
            </div>

            <div className="card content">
              <h1>🏆 Awards</h1>
              <ListContent primary="primary" items={awards}/>
            </div>

            <div className="card content">
              <h1>🤔 Interests</h1>
              <ListContent items={interests}/>
            </div>
          </Col>

          <Col xs={12} md={8}>
            <div className="card content">
              <h1>Project Demos</h1>
              <MediaFrame pictures={projectPictures} desc={projectPicturesDesc} links={projectLinks}/>
            </div>

            <div className="card content">
              <h1>Projects</h1>

              <HeaderContent title='OCR Word Search Solver | Python' date='Jan 2019' role='StarterHacks'/>
              <ListContent primary="primary" items={starterHacks}/>

              <HeaderContent title='Cryptography Web App | React, JS, CSS' date='Feb 2018' role='Educates user how plaintext turns into cipher-text'/>
              <ListContent primary="primary" items={crypWebApp}/>

              <HeaderContent title='Words Per Minute Web App | React, JS, CSS' date='May 2018' role='Tests users true typing speed'/>
              <ListContent primary="primary" items={wordsWebApp}/>

              <HeaderContent title='Arcade League of Legends - Digital Media Academy | Python' date='Aug 2016' role='Game development with Python'/>
              <ListContent primary="primary" items={digitalMediaAcademy}/>

              <HeaderContent title='Autonomous Vehicles - UofT DEEP Camp | Python' date='Aug 2015' role='Vehicle development with Python'/>
              <ListContent primary="primary" items={autoVehicle}/>
            </div>

            <div className="card content">
              <h1>💼 Work Experience</h1>
              <HeaderContent title='Chancellor Community Centre' date='Jan 2017 - Apr 2017' role='Swimming Instructor'/>
              <ListContent primary="primary" items={swimmingInstructor}/>
            </div>

            <div className="card content">
              <h1>📷 Photography</h1>
              <MediaFrame pictures={pictures} desc={picturesDesc}/>
            </div>
          </Col>
        </Row>
      </Grid>
    </div>);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js